import { useEffect } from 'react';
import { useIntl } from 'react-intl';

import { useRouter } from '@/hooks/useRouter';
import { EToastVariant, useToast } from '@/hooks/useToast';
import { IBooking } from '@/services/types/booking/details';

export const useReviewExpiredMessage = ({
  booking,
  hasReviewed,
}: {
  booking: Partial<IBooking> | null;
  hasReviewed: boolean | null;
}) => {
  const router = useRouter();
  const intl = useIntl();
  const { showToast } = useToast();
  const expiredMessage = intl.formatMessage({
    defaultMessage: 'This trip can no longer be reviewed.',
    id: 'iK2WMG',
  });

  const alreadySubmittedMessage = intl.formatMessage({
    defaultMessage: 'You have already submitted your review for this trip.',
    id: 'RJwu3n',
  });

  const oopsMessage = intl.formatMessage({ defaultMessage: 'Oops!', id: 'BEbOqj' });

  useEffect(() => {
    if (!booking || booking.can_renter_review || hasReviewed === null) return;

    // need timeout due to review and booking data are retrieved at different time
    const timeoutId = setTimeout(() => {
      showToast(
        EToastVariant.Error,
        oopsMessage,
        hasReviewed ? alreadySubmittedMessage : expiredMessage,
      );
      router.replace(`/trips/${booking.id}`, undefined, { shallow: true });
    }, 500);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [
    booking,
    hasReviewed,
    showToast,
    alreadySubmittedMessage,
    expiredMessage,
    router,
    oopsMessage,
  ]);
};
